import React, { createContext, ReactElement, ReactNode, useContext, useMemo } from 'react'

import { useFetchUserUmbrellas } from '../../../hooks/useFetchUserUmbrellas'
import { UserUmbrella } from './types/userUmbrella'

interface ContextState {
  userUmbrellas: UserUmbrella[]
}

const UserUmbrellasContext = createContext<ContextState | undefined>(undefined)

interface UserUmbrellasContextProps {
  children?: ReactNode
}

export const UserUmbrellasContextProvider = ({ children }: UserUmbrellasContextProps): ReactElement => {
  const { userUmbrellas } = useFetchUserUmbrellas()

  const contextValue = useMemo(() => ({ userUmbrellas }), [userUmbrellas])

  return <UserUmbrellasContext.Provider value={contextValue}>{children}</UserUmbrellasContext.Provider>
}

export const useUserUmbrellas = () => {
  const context = useContext(UserUmbrellasContext)

  if (!context) {
    throw new Error('UserUmbrellasContextProvider is missing in the module!')
  }

  return context
}
